"use client";
export const dynamic = "force-dynamic";

import BlogHeader from "@/components/blog/BlogHeader";
import BlogFooter from "@/components/blog/BlogFooter";

function BlogLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <BlogHeader />
      <main className="flex-1"></main>
      <BlogFooter />
    </div>
  );
}

export default BlogLayout;
